import Vue from 'vue'
import VueRouter, { Route } from 'vue-router'

import UpdateDocument from '@/components/documents/UpdateDocument.vue'
import ExploreDetail from '@/components/explore/ExploreDetail.vue'
import ProjectExplore from '@/components/explore/ProjectExplore.vue'
import NewPrivateDonationArea from '@/components/explore/NewPrivateDonationArea.vue'

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/project/:projectSlug',
      name: 'project-detail',
      component: ExploreDetail
    },
    {
      path: '/project/:projectSlug/donate',
      name: 'project-detail',
      component: NewPrivateDonationArea
    },
    {
      path: '/project/:projectSlug/:paymentRequestId',
      name: 'project-payment',
      component: UpdateDocument
    },
    {
      path: '/:slug/',
      name: 'explore-projects',
      component: ProjectExplore
    },
    {
      path: '/',
      name: 'explore-projects',
      component: ProjectExplore
    }
  ],
  scrollBehavior () {
    return { x: 0, y: 0, behavior: 'smooth' }
  }
})

let initialLoad: { route: Route; pageTitle: string } = null

router.afterEach((to) => {
  if (!initialLoad) {
    initialLoad = { route: to, pageTitle: document.title }
  }

  Vue.nextTick(() => {
    if (to.meta?.title) {
      document.title = to.meta.title
    } else if (initialLoad?.route.name === to.name) {
      document.title = initialLoad.pageTitle
    }
  })
})

export default router
